import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
    Modal,
    Button
} from 'react-bootstrap';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import Loader from '../Loader/Loader';

import { closeDeleteUserModal, openDeleteUserModal } from '../../actions/modalActions';
import { deleteUser } from '../../actions/siteadmin/users';

import cx from 'classnames';
import bt from '../../components/commonStyle.css';
import s from './DeleteUserForm.css';

import messages from '../../locale/messages';

class DeleteUserModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false
        };
    }

    static propTypes = {
        closeDeleteUserModal: PropTypes.any,
        openDeleteModal: PropTypes.bool,
        deleteUser: PropTypes.any,
        userId: PropTypes.string
    };
     handleClick = async (userId) => {
        const { deleteUser } = this.props;
        this.setState({ isLoading: true });
        await deleteUser(userId);
        this.setState({ isLoading: false });
    }
    render() {
        const { openDeleteModal, closeDeleteUserModal, deleteUser, userId, data } = this.props;
        const { formatMessage } = this.props.intl;
        const { isLoading } = this.state;

        return (
        
                <Modal show={openDeleteModal} onHide={closeDeleteUserModal} dialogClassName={'loginModal'} >
                    <Modal.Header closeButton>
                        <Modal.Title><FormattedMessage {...messages.deleteAccount} /></Modal.Title>
                    </Modal.Header>
                    <Modal.Body bsClass={s.logInModalBody}>
                        <div className={s.root}>
                            <div className={s.modalContent}>
                                <FormattedMessage {...messages.areYouSureDeleteAccount} />
                            </div>
                            <div className={s.deleteButtonContainer}>
                                <Button
                                    onClick={() => closeDeleteUserModal()} className={cx(bt.btnPrimaryBorder,'bgBlack')}>
                                    <FormattedMessage {...messages.cancel} />
                                </Button>
                                <Loader
                                    type={"button"}
                                    buttonType={"button"}
                                    show={isLoading}
                                    label={formatMessage(messages.proceed)}
                                    handleClick={() => { this.handleClick(userId) }}
                                    className={cx(bt.btnPrimary, "arButtonLoader", 'commonLoaderFlex')}
                                />
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            
        )
    }
}

const mapState = (state) => ({
    openDeleteModal: state?.modalStatus?.openDeleteModal,
    userId: state?.account?.data?.userId,
    data: state?.account?.data
});

const mapDispatch = {
    closeDeleteUserModal,
    deleteUser
};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(DeleteUserModal)));
